export const ADD_DAY_SUMMARIES = 'ADD_DAY_SUMMARIES';
export const DAY_SUMMARIES_REQUEST = 'DAY_SUMMARIES/REQUEST';
export const DAY_SUMMARIES_FAILED = 'DAY_SUMMARIES/FAILED';
export const LOAD_DAY_MDRS = 'LOAD_DAY_MDRS';
